var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "steam_home" } }, [
    _c("div", { staticClass: "caselist" }, [
      _c(
        "div",
        { staticClass: "bt_main st_scroll" },
        _vm._l(_vm.box_list.category, function (item, index) {
          return _c("div", { key: index, staticClass: "box_list" }, [
            _c("div", { staticClass: "box_title" }, [
              _c("p", [_vm._v(_vm._s(item))]),
              _c("i"),
            ]),
            _c(
              "div",
              { staticClass: "list" },
              _vm._l(
                _vm.box_list.list.filter(function (_) {
                  return _.catagory == item
                }),
                function (value, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "box_item",
                      on: {
                        click: function ($event) {
                          return _vm.to_open(value.caseId)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: value.saleIcon,
                              expression: "value.saleIcon",
                            },
                          ],
                          staticClass: "hot",
                        },
                        [_vm._v("最新！")]
                      ),
                      _c("div", { staticClass: "item_box" }, [
                        _c("div", { staticClass: "edge" }),
                        _c("div", { staticClass: "item_main" }, [
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgfilter")(value.itemPic),
                              alt: "",
                            },
                          }),
                        ]),
                      ]),
                      _c("p", [_vm._v(_vm._s(value.caseName))]),
                      _c("span", [_vm._v(_vm._s(value.price))]),
                    ]
                  )
                }
              ),
              0
            ),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "back_top", on: { click: _vm.totop } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }